export const encodeAugmentId = (augId) =>
  augId.replace(/TFT(.*?)_Augment_(.+)/, "$1$2");

export const encodeItemId = (itemId) =>
  itemId.replace(/TFT(.*?)_(Item|Consumable)_(.+)/, "$1$3");
